import { render, staticRenderFns } from "./AddAsset.vue?vue&type=template&id=04cf89dd&scoped=true"
import script from "./AddAsset.vue?vue&type=script&lang=js"
export * from "./AddAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf89dd",
  null
  
)

export default component.exports